module.exports = __webpack_public_path__ + "static/img/fabuwenzhang.fec4447.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pygh_index/fabuwenzhang.png
// module id = XJ4+
// module chunks = 5 7